// extracted by mini-css-extract-plugin
module.exports = {"ai-percent":"ai-percent___hKbU4"};